/**
 * UranIA PA — `/admin/banca-dati` (redirect a `/admin/corpus`).
 *
 * Fusione A.4.5 (Riordino della mappa delle rotte §4): il contenuto vive
 * ora su `/admin/corpus` (`routes/admin/corpus/index.tsx`). Questa rotta
 * resta solo come redirect.
 */

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as AmministrazioneSegmentRoute } from '../../_amministrazione.tsx';

export const Route = createRoute({
  getParentRoute: () => AmministrazioneSegmentRoute,
  path: '/admin/banca-dati',
  beforeLoad: () => {
    throw redirect({ to: '/admin/corpus', replace: true });
  },
});
